import React from 'react';

import {
  BuyAgainContainer,
  BuyAgainContent,
  BuyAgainImage,
  BuyAgainInfos,
  BuyAgainList,
  BuyAgainListItem,
  BuyAgainListItemText,
  BuyAgainListItemTitle,
  BuyAgainName,
  BuyAgainPrice,
  BuyAgainPriceContainer,
  BuyAgainTotalContainer,
  BuyAgainTotalText,
  BuyAgainTotalTitle,
  LinkButtonContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  RankBadge,
} from './styles';
import LegacyBottomSheet from '../../../Interface/LegacyBottomSheet';
import {Badge} from '../../../Interface/Badges/Badge';
import {LinkButton} from '../../../Interface/Forms/Buttons/LinkButton';
import {Button} from '../../../Interface/Forms/Buttons/Button';
import {useTheme} from 'styled-components/native';
import {useHelpers} from '../../../../context/helpers';
import {useNavigation} from '@react-navigation/native';

interface Orders {
  produto: string;
  valorAtualProduto: number;
  id_produto: {
    $oid: string;
  };
  litros: number;
  qtdCupons: number;
  valorAtualCompra: number;
  estado: string;
  cidade: string;
  categoria: string;
  tipoProduto: string;
  unidadeMedida: string;
  regiao: string;
  imagemProduto: string;
  dataAbastecimento?: string;
  horaAbastecimento?: string;
  postoAbastecimento?: string;
}

interface Props {
  showModal: boolean;
  onDismiss: () => void;
  data: Orders;
  success: () => void;
}

export function BuyAgainModal({showModal, onDismiss, success, data}: Props) {
  const theme = useTheme();
  const navigation = useNavigation();
  const {formatNumberToLocaleAmount} = useHelpers();

  function handleStations() {
    onDismiss();
    navigation.navigate('Stations', {id_produto: data.id_produto.$oid});
  }
  return (
    <LegacyBottomSheet isOpen={showModal} onClose={onDismiss}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Compre novamente mais rápido</ModalTitle>
        </ModalHeader>

        <BuyAgainContainer activeOpacity={1} disabled>
          <BuyAgainContent>
            <BuyAgainImage
              source={{
                uri: data.imagemProduto,
              }}
            />
            <BuyAgainInfos>
              <BuyAgainName>{data.produto}</BuyAgainName>
              <BuyAgainPriceContainer>
                <BuyAgainPrice>
                  {formatNumberToLocaleAmount(data.valorAtualProduto)}
                </BuyAgainPrice>
                <Badge
                  text={`${data.litros} ${
                    data.unidadeMedida === 'L'
                      ? ' Litros'
                      : ' ' + data.unidadeMedida
                  }`}
                  containerStyle={{
                    backgroundColor: theme.colors.primary,
                    borderColor: theme.colors.primary,
                  }}
                  textStyle={{color: theme.colors.shape}}
                />
              </BuyAgainPriceContainer>
            </BuyAgainInfos>
          </BuyAgainContent>

          <RankBadge
            source={{
              uri:
                data.categoria === 'ouro'
                  ? 'https://d3ag5cip9ldvh3.cloudfront.net/gold-medal.png'
                  : 'https://d3ag5cip9ldvh3.cloudfront.net/silver-medal.png',
            }}
          />
        </BuyAgainContainer>

        <BuyAgainList>
          {/**!!data.postoAbastecimento && (
            <BuyAgainListItem>
              <BuyAgainListItemTitle>Posto</BuyAgainListItemTitle>
              <BuyAgainListItemText>{data.postoAbastecimento}</BuyAgainListItemText>
            </BuyAgainListItem>
          )**/}

          {/**(data.dataAbastecimento || data.horaAbastecimento) && (
            <BuyAgainListItem>
              <BuyAgainListItemTitle>Abastecimento</BuyAgainListItemTitle>
              <BuyAgainListItemText>
                {[data.dataAbastecimento, data.horaAbastecimento]
                  .filter(Boolean)
                  .join(' • ')}
              </BuyAgainListItemText>
            </BuyAgainListItem>
          )**/}

          <BuyAgainListItem>
            <BuyAgainListItemTitle>Região</BuyAgainListItemTitle>
            <BuyAgainListItemText>
              {data.cidade} - {data.estado}
            </BuyAgainListItemText>
          </BuyAgainListItem>

          <BuyAgainListItem>
            <BuyAgainListItemTitle>Quantidade</BuyAgainListItemTitle>
            <BuyAgainListItemText>{data.qtdCupons}</BuyAgainListItemText>
          </BuyAgainListItem>

          <BuyAgainListItem>
            <BuyAgainListItemTitle>Categoria</BuyAgainListItemTitle>
            <BuyAgainListItemText>
              {data.categoria === 'ouro' ? 'Super Barato' : 'Barato'}
            </BuyAgainListItemText>
          </BuyAgainListItem>

          <BuyAgainListItem>
            <LinkButtonContainer>
              <LinkButton
                text={
                  data.tipoProduto === 'C'
                    ? 'Onde posso abastecer?'
                    : 'Onde retirar meu produto/serviço?'
                }
                enabled
                action={handleStations}
              />
            </LinkButtonContainer>
          </BuyAgainListItem>
        </BuyAgainList>

        <BuyAgainTotalContainer>
          <BuyAgainTotalTitle>Total: </BuyAgainTotalTitle>
          <BuyAgainTotalText>
            {formatNumberToLocaleAmount(data.valorAtualCompra)}
          </BuyAgainTotalText>
        </BuyAgainTotalContainer>

        <ModalFooter>
          <Button title="Finalizar compra" enabled onPress={success} />
        </ModalFooter>
      </ModalContent>
    </LegacyBottomSheet>
  );
}
